import { apiFetch } from "./client";

export interface AgentSecret {
  id: string;
  agentId: string;
  envName: string;
  description: string | null;
  vaultSecretName: string;
  vaultScope: string;
  createdAt: string;
  updatedAt: string;
}

export const agentSecretsApi = {
  list: (agentId: string) =>
    apiFetch<AgentSecret[]>(`/agents/${agentId}/secrets`),

  create: (agentId: string, data: { envName: string; value: string; description?: string; vaultScope?: string }) =>
    apiFetch<AgentSecret>(`/agents/${agentId}/secrets`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  remove: (agentId: string, secretId: string) =>
    apiFetch<void>(`/agents/${agentId}/secrets/${secretId}`, {
      method: "DELETE",
    }),

  sync: (agentId: string) =>
    apiFetch<{ success: boolean; secretCount: number; error?: string }>(`/agents/${agentId}/secrets/sync`, {
      method: "POST",
      body: JSON.stringify({}),
    }),
};
